import React from 'react';
import PropTypes from 'prop-types';

import { Title } from './styles';
import InvoiceTable from './InvoiceTable';
import texts from './texts.json';

const OneTimePaymentPanel = ({ invoiceList }) => (
  <>
    <Title>{texts.oneTimePaymentTitle}</Title>
    <InvoiceTable invoiceList={invoiceList} />
  </>
);

OneTimePaymentPanel.propTypes = {
  invoiceList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default OneTimePaymentPanel;
